import React from 'react';
import { Modal } from '../../components/ui';

// Phone version: full-screen list, one big tap target per number.
export default function NumberChoiceMobile({ vm }) {
  const { numberChoice, chooseContactNumber, cancelNumberChoice } = vm;
  if (!numberChoice) return null;
  const { contact, numbers } = numberChoice;
  const who = [contact.surname, contact.name].filter(Boolean).join(' ') || 'This contact';

  return (
    <Modal fullScreen title={`Which number? · ${who}`} onClose={cancelNumberChoice}
      footer={<button className="btn light" style={{ flex: 1, padding: 12 }} onClick={cancelNumberChoice}>Cancel</button>}>
      <div className="muted" style={{ fontSize: 12.5, marginBottom: 10 }}>
        {numbers.length} numbers saved for this contact — tap the one to invite.
      </div>
      <div className="num-choice">
        {numbers.map(n => (
          <button key={n.number} type="button" className="num-choice-row big" onClick={() => chooseContactNumber(n.number)}>
            <strong>{n.number}</strong>
            <span className="muted">{n.label || (n.mobile ? 'Mobile' : 'Other')}</span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
